import { getLeadId } from '../../temp/utilities/apiSession/leadId';

import * as Sentry from '@sentry/react';

import deleteJSON from 'utilities/deleteJSON';
import { API_BASE_URL } from 'utilities/env';
import getJSON from 'utilities/getJSON';
import postJSON from 'utilities/postJSON';

const getUrl = () => {
    const leadId = getLeadId();
    return `${API_BASE_URL}/Lead/${leadId}/Pharmacies`;
};

const addPharmacy = async ({ data }) => {
    const {
        pharmacyRecordID,
        pharmacyID,
        isMailOrder,
        name,
        address1,
        address2,
        city,
        zip,
        state,
        pharmacyPhone,
        pharmacyIDType
    } = data;

    const body = {
        pharmacyRecordID,
        pharmacyID,
        isMailOrder,
        name,
        address1,
        address2,
        city,
        zip,
        state,
        pharmacyPhone,
        pharmacyIDType
    };

    const url = getUrl();
    try {
        return await postJSON({ url, body });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

const deletePharmacy = async ({ id }) => {
    const url = `${getUrl()}/${id}`;
    try {
        return await deleteJSON({ url });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

const getPharmacies = async () => {
    try {
        return await getJSON({ url: getUrl() });
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};

export { addPharmacy, deletePharmacy, getPharmacies };
